
import { Navbar } from '../bordeaux/components/Navbar';
import { Hero } from '../bordeaux/components/Hero';
import { Services } from '../bordeaux/components/Services';
import { BayWindows } from '../bordeaux/components/BayWindows';
import { WhatsAppDiagnostic } from '../bordeaux/components/WhatsAppDiagnostic';
import { Contact } from '../bordeaux/components/Contact';
import { Footer } from '../bordeaux/components/Footer';
import { useEffect } from 'react';

export default function AndernosBains() {
  useEffect(() => {
    try {
      document.title = "Réparation Fenêtres Andernos-les-Bains | PVC Alu Bois | Baies Vitrées";
      
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', 'Expert en réparation de fenêtres à Andernos-les-Bains ✓ PVC, Aluminium, Bois ✓ Baies vitrées toutes marques ✓ Intervention rapide ✓ Devis gratuit');
      }

      const metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute('content', 'réparation fenêtres Andernos-les-Bains, fenêtres PVC Andernos, baies vitrées Andernos, vitrier Andernos-les-Bains');
      }

      const updateOrCreateMeta = (name: string, content: string) => {
        const meta = document.querySelector(`meta[name="${name}"]`) || document.createElement('meta');
        if (!meta.getAttribute('name')) {
          meta.setAttribute('name', name);
          document.head.appendChild(meta);
        }
        meta.setAttribute('content', content);
      };

      updateOrCreateMeta('geo.position', '44.7417;-1.1000');
      updateOrCreateMeta('geo.placename', 'Andernos-les-Bains, Gironde, France');
      updateOrCreateMeta('geo.region', 'FR-33');
    } catch (error) {
      console.error('Error updating meta tags:', error);
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar city="Andernos-les-Bains" />
      <Hero city="Andernos-les-Bains" />
      <Services city="Andernos-les-Bains" />
      <BayWindows city="Andernos-les-Bains" />
      <WhatsAppDiagnostic city="Andernos-les-Bains" />
      <Contact city="Andernos-les-Bains" />
      <Footer city="Andernos-les-Bains" />
    </div>
  );
}
